import { StateCreator } from "zustand";
import { ThreePsActions, ThreePsStore } from "./threePsTypes";
import { initialThreePsState } from "./threePsState";
import { DEFAULT_PAGE_INDEX } from "../threePsCodes.constants";

export const createThreePsStoreActions: StateCreator<ThreePsStore, [], [], ThreePsActions> = (set, get) => ({
    setSelectedVendor: (vendor, opts) => {
        const { force = false, setShowLoader } = opts ?? {};
        if (get().selectedVendor === vendor) return;

        set({ selectedVendor: vendor, pageIndex: DEFAULT_PAGE_INDEX });

        if (vendor) {
            get().fetchCodesByVendor(vendor, {
                force,
                setShowLoader,
                pageIndex: DEFAULT_PAGE_INDEX,
            });
        }
    },

    setIsEditMode: (isEditMode: boolean) => set({ isEditMode }),

    setPageSize: (pageSize: number) => set({ pageSize }),
    setPageIndex: (pageIndex: number) => set({ pageIndex }),
    setTotalThreePsCodes: (totalThreePsCodes: number) => set({ totalThreePsCodes }),
    
    clearVendorsError: () => set({ vendorsError: null }),
    clearCodesError: () => set({ codesError: null }),
    clearSaveError: () => set({ saveError: null }),
    resetThreePsState: () => set(initialThreePsState),
})
